import "./App.css";
import consts from "./consts.js";
import { useState } from "react";
import Footer from "./modules/Footer";
import Header from "./modules/Header";
import Main from "./modules/main";
import Toggle from "./modules/Toggle.js";

function App() {
  const [language, setLanguage] = useState(consts.ENGLISH);
  return (
    <div className="App">
      <div className="toggle">
        <Toggle language={language} setLanguage={setLanguage} />
      </div>

      <header className="App-header">
        <Header />
      </header>

      <div className="main">
        <Main language={language} />
      </div>

      <div className="footer">
        <Footer language={language} />
      </div>
    </div>
  );
}

export default App;
